import { report } from "process";

export const lang = {
  lang: "bn",
  welcome: "স্বাগতম",
  quickActions: "দ্রুত কার্যাবলী",
  eCommerceStoreSetup: "ই-কমার্স Store সেটআপ",
  country: "বাংলাদেশ",
  aamarID: "আমার আইডি",
  dashboard: "ড্যাশবোর্ড",
  pos: "পিওএস",
  sales: "বিক্রয়",
  customers: "গ্রাহক",
  accounts: "হিসাব",
  accountHead: "হিসাবের প্রধান",
  transaction: "লেনদেন",
  dueCollections: "বকেয়া আদায়",
  collection: "আদায়",
  ledgers: "লেজার রিপোর্ট",
  allCategories: " সব ক্যাটাগরি",
  subcategory: "সাব ক্যাটাগরি",
  importSubCategories: "সাব ক্যাটাগরি আমদানি করুন",
  addSubCategory: "সাব ক্যাটাগরি যোগ করুন",
  allSubcategories: "সকল সাব ক্যাটাগরি",
  category: "ক্যাটাগরি",
  categorySalesReport: "ক্যাটাগরি সেল রিপোর্ট",
  addCategory: "ক্যাটাগরি যোগ করুন",
  addNewCategory: "নতুন ক্যাটাগরি যোগ করুন",
  createNewGRN: "নতুন জিআরএন তৈরি করুন",
  products: "পণ্য",
  allProducts: "সকল পণ্য",
  addProduct: "পণ্য যোগ করুন",
  group: "গ্রুপ",
  generics: "জেনেরিক",
  brand: "ব্র্যান্ড",
  procurement: "সংগ্রহ",
  purchase: "ক্রয়",
  GRN: "জিআরএন",
  GRNReport: "জিআরএন রিপোর্ট",
  adjust: "অ্যাডজাস্ট",
  createAdjust: "অ্যাডজাস্ট যোগ করুন",
  stockIn: "স্টক ইন ",
  createStockIn: "স্টক যোগ করুন",
  RTV: "আরটিভি",
  returnToVendor: "বিক্রেতার কাছে ফেরত পাঠানো",
  createNewRTV: " নতুন আরটিভি যোগ করুন",
  createTpn: "টিপিএন যোগ করুন",
  createSupplier: "সরবরাহকারী যোগ করুন",
  TPN: "টিপিএন",
  supplier: "সরবরাহকারী",
  inventory: "ইনভেন্টরি",
  inventories: "ইনভেন্টরিসমূহ",
  stockLedger: "স্টক লেজার",
  movement: "চলাচল",
  damage: "ক্ষতি",
  exports: "এক্সপোর্ট",
  reports: "রিপোর্ট",
  allReports: "সকল রিপোর্ট",
  settings: "সেটিংস",
  backup: "ব্যাকআপ ও রিস্টোর",
  profileSetting: "প্রোফাইল সেটিংস",
  users: "ব্যবহারকারী",
  warehouse: "গুদাম",
  sms: "এসএমএস",
  accountsHead: "অ্যাকাউন্ট হেড",
  storeSetting: "দোকান সেটিংস",
  allAccountsHead: "সকল হিসাবের প্রধান",
  bucketSize: "বাকেট সাইজ",
  footFalls: "পদচিহ্ন",
  soldItems: "বিক্রিত পণ্য",
  returnItems: "ফেরতকৃত  পণ্য",
  todaysSales: "আজকের বিক্রয়",
  paymentsRecieved: "প্রাপ্ত অর্থ",
  vat: "ভ্যাট",
  duesCollection: "বকেয়া আদায়",
  articleSales: "আর্টিকেল সেল",
  pointSpent: "পয়েন্ট ব্যয়",
  categoryWiseArticleSales: "ক্যাটাগরি অনুযায়ী পণ্য বিক্রয়",
  allCategoriesSales: "সমস্ত ক্যাটাগরির বিক্রয়",
  today: "আজ",
  last3Days: "শেষ ৩ দিন",
  lastWeek: "শেষ সপ্তাহ",
  last30Days: "শেষ ৩০ দিন",
  exit: "প্রস্থান",
  finalizeSale: "বিক্রয় চূড়ান্ত করুন",
  totalQty: "মোট পরিমাণ",
  total: "মোট",
  vatTaxAmount: "ভ্যাট/ট্যাক্স পরিমাণ",
  LoyaltyPointSettings: " লয়েলটি পয়েন্ট কনফিগারেশন",
  grossTotal: "মোট মোট",
  grossTotalRound: "মোট মোট (গোল)",
  cashReceived: "প্রাপ্ত নগদ",
  card: "কার্ড",
  mfs: "এমএফএস",
  discount: "ছাড়",
  changeAmount: "পরিবর্তনের পরিমাণ",
  printBill: "বিল প্রিন্ট করুন",
  invoiceNo: "চালান নম্বর",
  bin: "বিআইএন",
  mushak: "মুশক",
  customerPhone: "গ্রাহকের ফোন",
  date: "তারিখ",
  customer: "গ্রাহক",
  biller: "বিল প্রদানকারী",
  outlet: "আউটলেট",
  orderDetails: "অর্ডার বিবরণ",
  item: "আইটেম",
  qty: "পরিমাণ",
  rate: "হার",
  noProductInPurchaseCart: "ক্রয় কার্টে কোনো পণ্য নেই",
  totalItem: "মোট আইটেম",
  dueAdjustment: "বকেয়া সমন্বয়",
  netAmount: "নেট পরিমাণ",
  totalReceived: "মোট প্রাপ্ত",
  bdt: "টাকা (BDT)",
  productSearch: "পণ্য অনুসন্ধান",
  stock: "স্টক",
  box: "বাক্স",
  noOfBox: "বাক্সের সংখ্যা",
  price: "মূল্য",
  quantity: "পরিমাণ",
  subTotal: "উপ-মোট",
  tk: "টাকা",
  itemNo: "আইটেম নম্বর",
  void: "বাতিল",
  hold: "অপেক্ষমাণ",
  refresh: "রিফ্রেশ",
  generic: "জেনেরিক",
  lastBill: "সর্বশেষ বিল",
  voidReturn: "বাতিল ফেরত",
  scanInvoice: "চালান স্ক্যান করুন",
  returnProduct: "ফেরত পণ্য",
  pleaseScanAnInvoice: "দয়া করে একটি চালান স্ক্যান করুন",
  crateReturn: "রিটার্ন তৈরি করুন",
  createUser: "ব্যবহারকারী তৈরি করুন",
  genericWiseProductSearch: "জেনেরিক অনুসারে পণ্য অনুসন্ধান",
  searchGeneric: "জেনেরিক অনুসন্ধান",
  tp: "টিপি",
  mrp: "এমআরপি",
  allSales: "সকল বিক্রয়",
  profile: "প্রোফাইল",
  signOut: "সাইন আউট",
  articleReport: "নিবন্ধ রিপোর্ট",
  categoryReport: "শ্রেণীভিত্তিক রিপোর্ট",
  downloadSalesReport: "বিক্রয় রিপোর্ট ডাউনলোড করুন",
  totalMrp: "মোট এমআরপি",
  earningDiscount: "উপার্জিত ছাড়",
  returnTotal: "মোট ফেরত",
  exportSales: "এক্সপোর্ট বিক্রয়",
  exportSalesCategoryWise: "শ্রেণী অনুযায়ী এক্সপোর্ট বিক্রয়",
  downloadArticleSalesReport: "নিবন্ধ বিক্রয় রিপোর্ট ডাউনলোড করুন",
  downloadCategorySalesReport: "শ্রেণীভিত্তিক বিক্রয় রিপোর্ট ডাউনলোড করুন",
  downloadCustomerDetails: "গ্রাহকের বিস্তারিত ডাউনলোড করুন",
  afterSalePayment: "বিক্রয় পরবর্তী অর্থ প্রদান",
  addExpense: "ব্যয় যোগ করুন",
  addPayment: "পেমেন্ট যোগ করুন",
  addAccountHead: "অ্যাকাউন্ট হেড যোগ করুন",
  updateAccountHead: "অ্যাকাউন্ট হেড আপডেট করুন",
  importProduct: "পণ্য ইম্পোর্ট",
  importCategories: "ক্যাটাগরি ইম্পোর্ট",
  addNewProduct: "নতুন পণ্য যোগ করুন",
  importGroup: "গ্রুপ ইম্পোর্ট করুন",
  importGeneric: "জেনেরিক ইম্পোর্ট করুন",
  importBrand: "ব্র্যান্ড ইম্পোর্ট করুন",
  
  importCustomer: "ইম্পোর্ট কাস্টমার",
  exportDetails: " ডিটেইলস এক্সপোর্ট করুন",
  updateGroup: "গ্রুপ আপডেট করুন",
  update: "আপডেট করুন",
  add: "যোগ করুন",
  createNewPurchase: "নতুন ক্রয় তৈরি করুন",
  createNewGrn: "নতুন জিআরএন তৈরি করুন",
  goodsReceiveNote: "পণ্য গ্রহণ নোট",
  productOutViaTPN: "টিপিএন মাধ্যমে পণ্য বাহির",
  importSupplier: "সরবরাহকারী ইম্পোর্ট করুন",
  addSupplier: "সরবরাহকারী যোগ করুন",
  updateSupplier: "সরবরাহকারী আপডেট করুন",
  inventoryMovement: "ইনভেন্টরি চলাচল",
  downloadMovementData: "চলাচল ডেটা ডাউনলোড করুন ",
  company: "কোম্পানি",
  name: "নাম",
  report: "রিপোর্ট",
  supplierLedger: "সরবরাহকারী লেজার",
  productsInventory: "পণ্যের ইনভেন্টরি",
  downloadInventoryData: "ইনভেন্টরি ডেটা ডাউনলোড করুন",
  createDamage: "ক্ষতি তৈরি করুন",
  downloadReport: "রিপোর্ট ডাউনলোড করুন",
  exportSalesPopularProducts: "জনপ্রিয় পণ্য এক্সপোর্ট বিক্রয়",
  printReport: "রিপোর্ট প্রিন্ট করুন",
  popularProducts: "জনপ্রিয় পণ্য",
  supplierSalesReport: "সরবরাহকারী বিক্রয় রিপোর্ট",
  allCategorySalesReport: "সকল শ্রেণী বিক্রয় রিপোর্ট",
  sampleImportFiles: "নমুনা ইম্পোর্ট ফাইল",
  exportSalesSupplierWise: "সরবরাহকারী ভিত্তিক এক্সপোর্ট বিক্রয়",
  loadingCSV: "CSV লোড হচ্ছে",
  createCustomer: "গ্রাহক নিবন্ধন",
  customerGroup: "কাস্টমার শ্রেণিবিভাগ",
  dueBills: "বকেয়া বিল",
  storeSettings: "দোকান সেটিংস",
  storeLogo: "দোকানের লোগো",
  basicInfo: "প্রাথমিক তথ্য",
  contactInfo: "যোগাযোগের তথ্য",
  posSettings: "POS সেটিংস",
  vatTaxSettings: "ভ্যাট ট্যাক্স সেটিংস",
  paymentSettings: "পেমেন্ট সেটিংস",
  smsWrapper: "এসএমএস মোড়ক",
  notePlease: "দয়া করে নোট করুন",
  createWarehouse: "গুদাম তৈরি করুন",
  updateWarehouse: "গুদাম আপডেট করুন",
  allUsers: "সকল ব্যবহারকারী",

  createNewUser: "নতুন ব্যবহারকারী তৈরি করুন",
  userDetails: "ব্যবহারকারীর বিবরণ",
  updateUser: "ব্যবহারকারী আপডেট করুন",
  security: "নিরাপত্তা",
};
